import React, { useEffect, useCallback, useState} from 'react';
import ProjectMetadata from './ProjectMetadata.js';
import {setShowProjectsModal} from 'actions/index.js';
import {useProjectMetadata} from "components/explore/useProjectMetadata.js"
import ExpandedProject from './ExpandedProject.js';
import {getWorkGraphic} from 'components/explore/work/getWorkGraphic.js';
import {formatDate} from 'components/selector2/formatDate.js';
import {getBlockDate} from 'utils/getBlockDate.js';
import Colors from 'components/Colors.js';
import ethereum from 'decentralized/ethereum.js';
import {getEdits} from './getEdits.js';
import {connect} from 'react-redux';

const colors = new Colors();

const ProjectOption = ({
    project,
    sequencerEngine,
    expanded,
    odd,
    setExpandedProject,
    setShowProjectsModal,
    viewMode
}) => { 
    const [date, setDate] = useState(undefined);
    const [showEdits, setShowEdits] = useState(undefined);
    const [user, setUser] = useState('');
    const [edits, setEdits] = useState([]);
    const [guildName, setGuildName] = useState(undefined);
    const [graphics, setGraphics] = useState(undefined);
    const [title, setTitle] = useState('');
    project.id = project.newSequence;

    const {isFavorited, isStarred} = useProjectMetadata({track: project});

    useEffect(() => {
        if (project.guildId) {
            ethereum.guildSequences._decryptQueryResult(
                project).then(
                    x => setTitle(x.title));
        } else {
            setTitle(project.title);
        }
    }, [project, setTitle]);

    useEffect(() => {
        if (showEdits) {
            getEdits(project.newSequence)
                .then(edits => {
                    console.log("edits for project = ", project.title, edits);
                    setEdits(edits);
                });
        } else {
            setEdits([])
        }
    }, [showEdits, project]);

    useEffect(() => {
        ethereum.users.getUserName(project.user)
            .then(name => setUser(name || project.user));
        getBlockDate(project.blockNumber)
            .then(x => setDate(x));
        if (project.guildId) {
            ethereum.guilds.getGuildName(project.guildId)
                .then(setGuildName);
        } else {
            setGuildName(undefined);
        }
    }, [project, setUser, setDate]);

    const onClickName = useCallback(() => {
        if (expanded) {
            setShowProjectsModal(false);
            sequencerEngine.loadSequence(project.newSequence);
        } else {
            setExpandedProject(project);
        }
    }, [setExpandedProject, project, expanded]);


    let style = {
        color: user ? colors.getColorForHash(user) : ''
    };
    let dotStyle = {
        borderColor: user ? colors.getColorForHash(user) : ''
    };
    let guildStyle = {
    };
    if (guildName) {
        guildStyle.color = colors.getColorForHash(guildName);
    }

    let className = "project-option";
    if (expanded) {
        className += " expanded";
    }
    if (project.metadata) {
        className += " has-metadata";
    }
    let projectOption = (
        <div className={className}>
          {/*<div onClick={onClickName} style={dotStyle} className="dot"/>*/}
          <div className="project-name">{title}</div>
         <div style={style} className="project-author">{user}</div>
          {project.edits > 0 ?
           <div
             onClick={() => setShowEdits(!showEdits)}
             className={showEdits ? "edits-btn showing" : "edits-btn"}>{project.edits} Edits</div>
           : ""}
          {isFavorited ? <div className="heart favorited"></div> : ''}
          {isStarred ?
           <div className="star starred">
             <span>&#9734;</span>
           </div> : ''}
          <div className="project-bpm">
            <div style={{width: Math.min(1, project.bpm/200)*60}} className="bpm-slider"/>
            <div className="bpm-text">
              BPM: {project.bpm}
            </div>
          </div>
          <div className="project-date">{date ? formatDate(date) : ''}</div>
          
          {project.contentKey ? <div className="private-project">Private</div> : ''}
          {guildName ? <div style={guildStyle} className="project-guild">{guildName}</div> : ''}
          {project.isLocal ? <div className="local-only">Not Synced</div> : ''}
        </div>);

    if (showEdits) {
        return (
            <div className="expanded-project">
              {projectOption}
              <div className="project-edits">
                {edits.map(
                    edit =>
                        <ProjectOption
                          setExpandedProject={setExpandedProject}
                          expanded={expanded}
                          project={edit}
                          sequencerEngine={sequencerEngine} />)}
              </div>
            </div>
        );
    }
    let _class = project.metadata ? "project-option-wrapper has-metadata" : "project-option-wrapper";
    if (odd) {
        _class+=" odd";
    }
    if (viewMode === "GRID") {
        _class += " pushable";
    }
    return <div
             onClick={onClickName} 
             className={_class}>
             {projectOption}
             <ProjectMetadata projectHash={project.newSequence} metadata={project.metadata}/>
           </div>;
}

const mapStateToProps = (state, props) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
      setShowProjectsModal: x => dispatch(setShowProjectsModal(x))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ProjectOption);
